<template>
  <div class="board home-board">
    <div class="content">
      <h1>{{ $t('boards.title', { app_name: app.name }) }}</h1>

      <p>{{ $t('boards.subtitle') }}</p>

      <p v-for="board in boards" :key="board.id">
        <router-link :to="getLink(board)" class="button is-link">{{ board.title }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("application", ["app", "boards"])
  },

  methods: {
    getLink(board) {
      return board.is_board
        ? { name: "overview", params: { boardId: board.id } }
        : { name: board.id };
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
